import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import WebBookingManager from "./WebBookingManager";
import * as serviceWorker from "./serviceWorker";
import { IntlProvider } from "react-intl";
import { captureBootAuth } from "./helpers/bootAuth";
import { bootMigration } from "./helpers/session";
import messages_es from "./translations/es.json";
import messages_en from "./translations/en.json";
import messages_pt from "./translations/pt.json";

// Si el bundle se ejecuta dos veces en la misma página (pasó con un runtime de webpack
// duplicado en index.php), la segunda ejecución ve la URL ya sin el token (#t=) y la app
// arranca sin sesión: el link de acceso "no hace nada". Sólo arranca la primera.
const alreadyBooted =
  process.env.NODE_ENV === "production" && window.__pxWbmBooted === true;
window.__pxWbmBooted = true;

// Antes de renderizar: migraciones de almacenamiento y captura (y borrado de la
// URL) del token de acceso.
if (!alreadyBooted) {
  bootMigration();
  captureBootAuth();
}

const messages = {
  es: messages_es,
  en: messages_en,
  pt: messages_pt
};

const language =
  navigator.language?.split("-")[0] || navigator.userLanguage?.split("-")[0];

// let urlLngEn = window.location.href.indexOf("/en/") !== -1 ? "en" : false;
// let urlLngPt = window.location.href.indexOf("/pt/") !== -1 ? "pt" : false;
// const language = urlLngEn || urlLngPt ? urlLngEn || urlLngPt : "es";

if (!alreadyBooted) {
  ReactDOM.render(
    <React.StrictMode>
      <IntlProvider
        locale={language}
        messages={messages?.[language] || messages?.en}
      >
        <WebBookingManager language={language} />
      </IntlProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

// If you want your WebBookingManager to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register({
//   scope: language === 'es' ? '/app/' : `/${language}/app/`
//  });
